import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import api from '../../api/axiosInstance';
import API_PATH from '../../api/apiPath';

export default function Footer() {
    const [showPdf, setShowPdf] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null); // ✅ track which policy is selected
    const [allPolicies, setAllPolicies] = useState([]);

    const getAllPolicy = async () => {
        try {
            const res = await api.get("/policies/get-policies", {
                params: {
                    layoutArea: 'footer'  // ✅ sends as ?areaLayout=footer
                } 
            } );
            console.log("res", res.data.policies)
            if (res.data.success && Array.isArray(res.data.policies)) {
                setAllPolicies(res.data.policies);
            }
        } catch (error) {
            console.error("Error fetching policies:", error);
        }
    };

    useEffect(() => {
        getAllPolicy();
    }, []);

    const handleOpenPdf = (policy) => {
        setSelectedPolicy(policy); // ✅ store clicked policy
        setShowPdf(true);
    };

    const handleClosePdf = () => {
        setShowPdf(false);
        setSelectedPolicy(null);
    };

    return (
        <div>
            <footer className="footer pt-5">
                <div className="container-fluid plr">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="logo-footer mb-5">
                                <img src="/assets/images/footer-logo.png" alt="" srcSet="" />
                            </div>
                            <div className="footer-menu d-flex">
                                <div>
                                    <h5>About Us</h5>
                                    <ul className="footer-links">
                                        <li>
                                            <Link to="/about-us/who-we-are">
                                                Who We Are
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/about-us/leadership-team">
                                                Leadership Team
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/about-us/project-portfolio">
                                                Project Portfolio
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <h5>Business</h5>
                                    <ul className="footer-links">
                                        <li>
                                            <Link 
                                                to="/business/pre-development-epc" 
                                            >
                                                Pre-Development EPC
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/business/turnkey-epc-projects" >
                                                Turnkey EPC Projects
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="/business/grid-infrastructure">
                                                Grid Infrastructure
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/business/independent-power-producer">
                                                Independent Power Producer
                                            </Link>
                                        </li>

                                    </ul>
                                </div>
                                <div>
                                    <h5>Resources</h5>
                                    <ul className="footer-links">
                                        <li>
                                            <Link to="/blogs">
                                                Blogs
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/case-studies">
                                                Case Studies
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/faqs">
                                                FAQs
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <a href="/newsroom"><h5>News Room</h5></a>
                                    <ul className="footer-links">
                                        <li>
                                            <Link to="/press-release">
                                                Press Release
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/media-coverages">
                                                Media Coverage
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/media-resources">
                                                Media Resources
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <h5>
                                        <Link to="/culture" className="text-decoration-none text-white">
                                            Culture
                                        </Link>
                                    </h5>
                                    <h5 className='d-none'>
                                        <Link to="/investors" className="text-decoration-none text-white">
                                            Investor
                                        </Link>
                                    </h5>
                                    <h5>
                                        <Link to="/awards" className="text-decoration-none text-white">
                                            Awards
                                        </Link>
                                    </h5>
                                    <h5>
                                        <Link to="/careers" className="text-decoration-none text-white">
                                            Careers
                                        </Link>
                                    </h5>
                                    <h5>
                                        <Link to="/contact-us" className="text-decoration-none text-white">
                                            Contact
                                        </Link>
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-10">
                            <div className="footer-menu contact">
                                <h5>Headquarter</h5>
                                <ul className="">
                                    <li>
                                        AIPL Business Club, Tower-3, 12th Floor, Sector - 62, Gurugram -
                                        122002, Haryana
                                    </li>
                                    <li>
                                        <img src="/assets/images/phone-icon.png" alt="" srcSet="" />
                                        <a href="tel:+911244529332">+91-124-452-9332</a>
                                    </li>
                                    <li>
                                        <img src="/assets/images/mail-icon.png" alt="" srcSet="" />
                                        <a href="mailto:info@dattainfra.com">info@dattainfra.com</a>
                                    </li>
                                </ul>
                                <ul className="social-icons d-flex align-items-center gap-1 mt-4">
                                    <li>
                                        <a href="https://www.facebook.com/share/162UfiWyhq/?mibextid=wwXIfr">
                                            <i className="fa fa-facebook-f custom-fa" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://x.com/DattaPowerInfra'>
                                            <i className="bi bi-twitter-x custom-fa" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://www.linkedin.com/company/datta-power-infra/posts/?feedView=all'>
                                            <i className="fa fa-linkedin custom-fa" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://www.instagram.com/dattainfra/'>
                                            <i className="fa fa-instagram custom-fa" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://youtube.com/@dattapowerinfra?si=O4eVtLD4h48BLO4f">
                                            <i className="fa fa-youtube-play custom-fa" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="row border-top copy-section">
                            <div className="col-lg-7">
                                <p className='text-white'> Copyright © 2026 DPIPL. All rights reserved.</p>
                            </div>
                            <div className="col-lg-5 copy-list">
                                {/* ✅ Dynamically render all policies */}
                                {allPolicies.map((policy) => (
                                    <Link
                                        key={policy.id}
                                        className="text-decoration-none text-white"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleOpenPdf(policy);
                                        }}
                                    >
                                        {policy.title.toUpperCase()}
                                    </Link>
                                ))}
                            </div>
                          
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="copyright" />
                        </div>
                    </div>
                </div>
            </footer>
            {/* ✅ PDF Viewer Modal */}
            {showPdf && selectedPolicy && selectedPolicy.policyDocument &&  (
                <>
                    {/* ✅ Prevent body scroll when modal open */}
                    <style>{`body { overflow: hidden; }`}</style>

                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,          // ✅ use all 4 sides instead of width/height
                            backgroundColor: "rgba(0,0,0,0.6)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 99999,
                        }}
                        onClick={handleClosePdf}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                width: "80vw",
                                height: "90vh",
                                borderRadius: "8px",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Header */}
                            <div style={{
                                padding: "10px 15px",
                                borderBottom: "1px solid #eee",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                height: "50px",
                                flexShrink: 0,
                            }}>
                                <h6 style={{ margin: 0 }}>{selectedPolicy.title}</h6>
                                <button
                                    onClick={handleClosePdf}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        fontSize: "24px",
                                        cursor: "pointer",
                                    }}
                                >
                                    &times;
                                </button>
                            </div>

                            {/* iframe */}
                            <iframe
                                src={`${API_PATH}/${selectedPolicy.policyDocument}#toolbar=0`}
                                title={selectedPolicy.title}
                                style={{
                                    border: "none",
                                    flex: 1,
                                    width: "100%",
                                    minHeight: 0,   // ✅ critical fix for flex children
                                    display: "block",
                                }}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
